import { render, staticRenderFns } from "./FavouritesButton.vue?vue&type=template&id=6e3ddc6e&scoped=true&"
import script from "./FavouritesButton.vue?vue&type=script&lang=js&"
export * from "./FavouritesButton.vue?vue&type=script&lang=js&"
import style0 from "./FavouritesButton.vue?vue&type=style&index=0&id=6e3ddc6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3ddc6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
